export default __webpack_public_path__ + "static/threebestrated-2e811b73741570546f1f370cf3fe2c28.svg";